(function () {
  'use strict';

  const MOBILE_MEDIA_QUERY = '(max-width: 749px)';

  // Must match .immersive-hero__frame's width/height transition duration in the CSS.
  const FRAME_SHRINK_MS = 1600;
  // Panels start before the frame's shrink has fully finished, so the two motions
  // overlap instead of running strictly one-after-the-other.
  const PANEL_REVEAL_DELAY_MS = 900;
  // The video only starts once the card has actually finished shrinking.
  const VIDEO_START_DELAY_MS = FRAME_SHRINK_MS;

  function playVideo(video) {
    if (!video) return;
    // Autoplay only works muted - the mute toggle lets the visitor turn sound on afterwards.
    video.muted = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function initVideoControls(root, video) {
    if (!video) return;

    const controls = root.querySelector('[data-immersive-hero-video-controls]');
    if (!controls) return;

    const playToggle = controls.querySelector('[data-immersive-hero-play-toggle]');
    const muteToggle = controls.querySelector('[data-immersive-hero-mute-toggle]');

    function setIcon(button, name) {
      if (!button) return;
      button.querySelectorAll('[data-immersive-hero-icon]').forEach(function (icon) {
        icon.hidden = icon.getAttribute('data-immersive-hero-icon') !== name;
      });
    }

    function updatePlayButton() {
      if (!playToggle) return;
      const isPaused = video.paused;
      playToggle.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
      playToggle.setAttribute('aria-label', isPaused ? controls.dataset.playVideoLabel : controls.dataset.pauseVideoLabel);
      setIcon(playToggle, isPaused ? 'play' : 'pause');
      const label = playToggle.querySelector('[data-immersive-hero-play-label]');
      if (label) label.textContent = isPaused ? controls.dataset.playLabel : controls.dataset.pauseLabel;
    }

    function updateMuteButton() {
      if (!muteToggle) return;
      const isMuted = video.muted;
      muteToggle.setAttribute('aria-pressed', isMuted ? 'true' : 'false');
      muteToggle.setAttribute('aria-label', isMuted ? controls.dataset.unmuteVideoLabel : controls.dataset.muteVideoLabel);
      setIcon(muteToggle, isMuted ? 'muted' : 'unmuted');
      const label = muteToggle.querySelector('[data-immersive-hero-mute-label]');
      if (label) label.textContent = isMuted ? controls.dataset.unmuteLabel : controls.dataset.muteLabel;
    }

    if (playToggle) {
      playToggle.addEventListener('click', function () {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    }

    if (muteToggle) {
      muteToggle.addEventListener('click', function () {
        video.muted = !video.muted;
        updateMuteButton();
      });
    }

    video.addEventListener('play', updatePlayButton);
    video.addEventListener('pause', updatePlayButton);

    updatePlayButton();
    updateMuteButton();
  }

  function initDesktop(root, frame, video, reduceMotion) {
    if (reduceMotion) {
      root.classList.add('is-condensed', 'is-visible');
      playVideo(video);
      return;
    }

    // Lock the frame's current rendered pixel size, force the browser to commit that
    // layout, then switch to the target size in the same tick. Reading offsetHeight
    // in between forces the reflow that makes the width/height transition reliable
    // (transitioning straight from a percentage/aspect-ratio-derived size doesn't
    // animate consistently across browsers).
    const rect = frame.getBoundingClientRect();
    frame.style.width = rect.width + 'px';
    frame.style.height = rect.height + 'px';
    void frame.offsetHeight;

    frame.style.removeProperty('width');
    frame.style.removeProperty('height');
    root.classList.add('is-condensed');

    window.setTimeout(function () {
      root.classList.add('is-visible');
    }, PANEL_REVEAL_DELAY_MS);

    window.setTimeout(function () {
      playVideo(video);
    }, VIDEO_START_DELAY_MS);
  }

  function initMobile(root, video, reduceMotion) {
    // The main card is already full width on mobile - nothing to wait for.
    playVideo(video);

    const revealTargets = root.querySelectorAll('[data-immersive-hero-reveal]');
    if (!revealTargets.length) return;

    if (reduceMotion || typeof IntersectionObserver === 'undefined') {
      revealTargets.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    revealTargets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initImmersiveHero(root) {
    if (root.dataset.ihInit === 'true') return;
    root.dataset.ihInit = 'true';

    const frame = root.querySelector('[data-immersive-hero-frame]');
    const video = frame ? frame.querySelector('video') : null;

    if (!frame) return;

    initVideoControls(root, video);

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (window.matchMedia(MOBILE_MEDIA_QUERY).matches) {
      initMobile(root, video, reduceMotion);
      return;
    }

    initDesktop(root, frame, video, reduceMotion);
  }

  function boot() {
    document.querySelectorAll('[data-immersive-hero]').forEach(initImmersiveHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
